// frontend/src/components/common/MenuGlyph.jsx
import React from 'react';
import { menuGlyphBars } from './menuGlyphBars';

/**
 * The menu (hamburger) glyph. Not a Phosphor icon — see menuGlyphBars.js for
 * why this one is hand-authored and why its viewBox tracks the rendered size.
 *
 * Exported to the app as MenuIcon (src/icons.js) and takes the same props as
 * the Phosphor glyphs beside it, so a call site cannot tell which of the two
 * it is rendering. That substitutability is the point: the pixel-grid problem
 * is this module's business, not the caller's.
 *
 * Decorative: every button using this glyph carries its own aria-label, so
 * exposing the SVG to assistive tech would only double it up.
 */
export default function MenuGlyph({ size = 18, className, style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      className={className}
      style={style}
    >
      {menuGlyphBars(size).map((bar) => (
        <rect key={bar.y} x={bar.x} y={bar.y} width={bar.width} height={bar.height} />
      ))}
    </svg>
  );
}
